import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
import { ResponsivePicture } from "../../../Shared/components/Image";
import { BranchLocalizationLayout } from '../../../Shared/components/Jumbo/BranchLocalization/BranchLocalizationLayout';
import { Container } from '../../../Shared/components/Container';
import { JumboOpeningHours } from '../../../Shared/components/Jumbo/OpeningHours/JumboOpeningHours';
import { Link } from '../../../Shared/components/Link';
import { hyphenate } from '../../../Shared/features/hyphenate';
import { LinkButton } from './library/button';
import { trackJumboButton } from './library/tracking';
export const jumboStateZero = {};
export const renderContents = (contents, htmlElement, jsxElement)=>{
    return typeof contents == 'string' ? /*#__PURE__*/ _createElement(htmlElement.type, {
        ...htmlElement.props,
        key: htmlElement.key,
        dangerouslySetInnerHTML: {
            __html: contents
        }
    }) : /*#__PURE__*/ _jsx(jsxElement.type, {
        ...jsxElement.props,
        children: contents
    }, jsxElement.key);
};
const JumboHeading = (props)=>{
    const { supertitle, title, subtitle, HeadingLevel = 'h1' } = props;
    return /*#__PURE__*/ _jsxs("header", {
        children: [
            supertitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__supertitle title--md",
                children: supertitle
            }),
            /*#__PURE__*/ _jsx(HeadingLevel, {
                className: "jumbotron__title title--xl",
                children: title
            }),
            subtitle && /*#__PURE__*/ _jsx("span", {
                className: "jumbotron__subtitle title--md",
                children: subtitle
            })
        ]
    });
};
export const Jumbo = (props)=>{
    const Wrapper = props.size == 'large' && props.kind === 'home-location' ? 'section' : 'header';
    const HeadingLevel = props.size == 'large' && props.kind === 'home-location' ? 'h2' : 'h1';
    const { supertitle, title, subtitle } = props;
    // Calendar v3 overview header, identical for every tenant
    if (props.kind === 'activity-overview') return /*#__PURE__*/ _jsx("header", {
        className: "jumbotron jumbotron--activity-overview",
        children: /*#__PURE__*/ _jsxs(Container, {
            size: "m",
            gutter: true,
            className: "jumbotron__inner",
            children: [
                /*#__PURE__*/ _jsxs("nav", {
                    className: "jumbotron__breadcrumbs",
                    "aria-label": "Kruimelpad",
                    children: [
                        /*#__PURE__*/ _jsxs(Link, {
                            url: "/",
                            className: "jumbotron__back-link",
                            children: [
                                /*#__PURE__*/ _jsx("svg", {
                                    width: "1.5rem",
                                    height: "1.5rem",
                                    "aria-hidden": "true",
                                    children: /*#__PURE__*/ _jsx("use", {
                                        xlinkHref: "#icon--chevron-left-large"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    children: "Terug naar home"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("ol", {
                            className: "jumbotron__breadcrumb-list",
                            children: [
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "jumbotron__breadcrumb",
                                    children: [
                                        /*#__PURE__*/ _jsx(Link, {
                                            url: "/",
                                            className: "jumbotron__breadcrumb-link",
                                            children: "Home"
                                        }),
                                        /*#__PURE__*/ _jsx("svg", {
                                            width: "1.5rem",
                                            height: "1.5rem",
                                            "aria-hidden": "true",
                                            children: /*#__PURE__*/ _jsx("use", {
                                                xlinkHref: "#icon--chevron-right-large"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "jumbotron__breadcrumb",
                                    "aria-current": "page",
                                    children: "Activiteiten"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("h1", {
                    className: "jumbotron__title title--xl",
                    children: hyphenate(props.title)
                })
            ]
        })
    });
    return props.size == 'large' ? props.kind === 'home' || props.kind === 'home-location' ? // Homepage/Location page: has title, intro, button and image (50-50 columns)
    /*#__PURE__*/ _jsxs(Wrapper, {
        className: `jumbotron jumbotron--large jumbotron--home${props.kind === 'home-location' ? ' jumbotron--faux' : ''}`,
        children: [
            (props.kind === 'home-location' || props.kind === 'home') && props.localizationProps && /*#__PURE__*/ _jsx(BranchLocalizationLayout, {
                selectedLocationId: props.localizationProps.selectedLocationId,
                branchLocations: props.localizationProps.branchLocations,
                selectLocation: props.localizationProps.selectLocation
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "jumbotron__outer",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "jumbotron__inner container--full gutter--m align--center",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "jumbotron__content container--s",
                            children: [
                                /*#__PURE__*/ _jsx(JumboHeading, {
                                    ...props,
                                    HeadingLevel: HeadingLevel
                                }),
                                props.contents.toString().length > 0 || props.buttonUrl && props.buttonTitle ? /*#__PURE__*/ _jsxs("div", {
                                    className: "jumbotron__intro",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "text--styled",
                                            children: props.contents.toString().length > 0 && renderContents(props.contents, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {}))
                                        }),
                                        props.openingHours && /*#__PURE__*/ _jsx(JumboOpeningHours, {
                                            ...props.openingHours
                                        }),
                                        props.buttonUrl && props.buttonTitle && /*#__PURE__*/ _jsx(LinkButton, {
                                            variant: "black",
                                            arrow: false,
                                            route: props.buttonUrl,
                                            handle: ()=>trackJumboButton(props.buttonTitle),
                                            className: "button button--primary button--arrow jumbotron__clickable",
                                            children: props.buttonTitle
                                        })
                                    ]
                                }) : /*#__PURE__*/ _jsx(_Fragment, {})
                            ]
                        }),
                        props.imageUrl && /*#__PURE__*/ _jsx("div", {
                            className: "jumbotron__visual fit-object",
                            "aria-hidden": "true",
                            children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                                defaultImageUrl: props.imageUrlFallback,
                                cropsPerMedia: [
                                    {
                                        crops: [
                                            {
                                                url: props.imageUrlSmall,
                                                width: 624
                                            },
                                            {
                                                url: props.imageUrl,
                                                width: 1248
                                            },
                                            {
                                                url: props.imageUrlLarge,
                                                width: 1848
                                            }
                                        ]
                                    }
                                ],
                                width: 1248,
                                height: 848,
                                lazyload: false,
                                alt: props.imageAlt
                            })
                        })
                    ]
                })
            })
        ]
    }) : // Default 'large': has title, intro, button and image (55-45 columns) (+ filter bar on Activity/Collection page)
    /*#__PURE__*/ _jsx("header", {
        className: `jumbotron jumbotron--large jumbotron--default${props.kind === 'activity' || props.kind === 'collection' ? ' jumbotron--activity' : ''}`,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "jumbotron__inner container--full gutter--m align--center",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "jumbotron__content container--s",
                    children: [
                        /*#__PURE__*/ _jsx(JumboHeading, {
                            ...props
                        }),
                        props.contents.toString().length > 0 || props.buttonUrl && props.buttonTitle ? /*#__PURE__*/ _jsxs("div", {
                            className: "jumbotron__intro",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text--styled",
                                    children: [
                                        props.contents.toString().length > 0 && renderContents(props.contents, /*#__PURE__*/ _jsx("div", {}), /*#__PURE__*/ _jsx("div", {})),
                                        props.openingHours && /*#__PURE__*/ _jsx(JumboOpeningHours, {
                                            ...props.openingHours
                                        })
                                    ]
                                }),
                                props.buttonUrl && props.buttonTitle && /*#__PURE__*/ _jsx(LinkButton, {
                                    variant: "white",
                                    arrow: true,
                                    route: props.buttonUrl,
                                    handle: ()=>trackJumboButton(props.buttonTitle),
                                    className: "button button--primary button--arrow jumbotron__clickable",
                                    children: props.buttonTitle
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(_Fragment, {})
                    ]
                }),
                props.imageUrl && /*#__PURE__*/ _jsx("div", {
                    className: "jumbotron__visual fit-object",
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                        defaultImageUrl: props.imageUrlFallback,
                        lazyload: false,
                        cropsPerMedia: [
                            {
                                crops: [
                                    {
                                        url: props.imageUrlSmall,
                                        width: 624
                                    },
                                    {
                                        url: props.imageUrl,
                                        width: 1248
                                    },
                                    {
                                        url: props.imageUrlLarge,
                                        width: 1848
                                    }
                                ]
                            }
                        ],
                        width: 1248,
                        height: 848,
                        alt: props.imageAlt
                    })
                })
            ]
        })
    }) : // Default 'small': has title and intro
    /*#__PURE__*/ _jsxs("header", {
        className: "jumbotron jumbotron--small",
        children: [
            (props.kind === 'home-location' || props.kind === 'home') && props.localizationProps && /*#__PURE__*/ _jsx(BranchLocalizationLayout, {
                selectedLocationId: props.localizationProps.selectedLocationId,
                branchLocations: props.localizationProps.branchLocations,
                selectLocation: props.localizationProps.selectLocation
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "jumbotron__inner container--mg align--center",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "jumbotron__content container--s",
                        children: [
                            props.topContent,
                            /*#__PURE__*/ _jsx(JumboHeading, {
                                ...props,
                                HeadingLevel: HeadingLevel
                            }),
                            props.contents.toString().length > 0 && /*#__PURE__*/ _jsx("div", {
                                className: "jumbotron__intro text--styled container--s",
                                children: renderContents(props.contents, /*#__PURE__*/ _jsx("p", {}), /*#__PURE__*/ _jsx("div", {}))
                            }),
                            props.openingHours && /*#__PURE__*/ _jsx(JumboOpeningHours, {
                                ...props.openingHours
                            })
                        ]
                    }),
                    props.imageUrl && /*#__PURE__*/ _jsx("div", {
                        className: "jumbotron__visual fit-object",
                        children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                            defaultImageUrl: props.imageUrlFallback,
                            cropsPerMedia: [
                                {
                                    crops: [
                                        {
                                            url: props.imageUrl,
                                            width: 440
                                        },
                                        {
                                            url: props.imageUrlLarge,
                                            width: 880
                                        }
                                    ]
                                }
                            ],
                            width: 440,
                            height: 440,
                            lazyload: false,
                            alt: props.imageAlt
                        })
                    })
                ]
            })
        ]
    });
};
{}